import { createAction, handleActions } from 'redux-actions';
import { Api } from "../../api/api";
import { logout, onForbidden } from '../account/login';
import _ from 'lodash';
import { fetchSubmitForm, resetSubmitFormData, fetchSubmitFormFailed } from '../common/submitForm';
import { hideModal } from '../common/activeModal';

//- Actions
export const fetchGetOrgsWithoutCertificatesFailed = createAction('FETCH_GET_ORGS_WITHOUT_CERTIFICATES_FAILED');
export const fetchGetOrgsWithoutCertificatesSuccess = createAction('FETCH_GET_ORGS_WITHOUT_CERTIFICATES_SUCCESS');
export const onFetchAddFirstOrgCertificate = (page) => (data) => dispatch => {
    if (data.content.length === 0 && page && page > 0) {
        dispatch(fetchGetOrgsWithoutCertificates(0));
    } else {
        dispatch(fetchGetOrgsWithoutCertificatesSuccess(data));
    }
};
export const fetchGetOrgsWithoutCertificates = createAction(
    'FETCH_GET_ORGS_WITHOUT_CERTIFICATES',
    (page) => Api.getOrgsWithoutCertificates(page),
    (page) => ({
        apiCall: true,
        onSuccess: onFetchAddFirstOrgCertificate(page),
        onFail: fetchGetOrgsWithoutCertificatesFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const updateCertificatesData = createAction('UPDATE_CERTIFICATES_DATA');

export const fetchAddFirstOrgCertificate = (orgId, data) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onAddFirstOrgCertificate(orgId, data));
};
export const onAddFirstOrgCertificate = createAction(
    'FETCH_ADD_ORG_CERTIFICATE',
    (orgId, data) => Api.addOrgCertificate(orgId, data),
    (orgId, data) => ({
        apiCall: true,
        onSuccess: onAddFirstOrgCertificateSuccess(orgId),
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const onAddFirstOrgCertificateSuccess = (orgId) => (data) => (dispatch, getState) => {
    let certificatesData = _.cloneDeep(getFirstCertificatesData(getState()));
    certificatesData[orgId] = data;
    dispatch(updateCertificatesData(certificatesData))
    dispatch(hideModal());
    dispatch(resetSubmitFormData());
};

export const removeOrgWithoutCertificatesFromPage = (orgId) => (dispatch, getState) => {
    let data = _.cloneDeep(getOrgsWithoutCertificatesData(getState()));
    data = _.filter(data, (elem) => elem.id !== orgId);
    dispatch(updateOrgsWithoutCertificatesPage(data));
    if (data.length === 0) {
        dispatch(fetchGetOrgsWithoutCertificates(0));
    }
};

export const updateOrgsWithoutCertificatesPage = createAction('UPDATE_ORGS_WITHOUT_CERTIFICATES_PAGE');

//- State
const initialState = {
    fetching: false,
    data: null,
    error: null,
    currentPage: null,
    totalPages: null,
    certificatesData: {}
};

//- Reducers
export default handleActions({
    FETCH_GET_ORGS_WITHOUT_CERTIFICATES: (state) => {
        return { ...state, data: null, currentPage: null, totalPages: null, error: null, fetching: true };
    },
    FETCH_GET_ORGS_WITHOUT_CERTIFICATES_FAILED: (state, action) => {
        return { ...state, data: null, currentPage: null, totalPages: null, error: action.payload, fetching: false };
    },
    FETCH_GET_ORGS_WITHOUT_CERTIFICATES_SUCCESS: (state, action) => {
        return { ...state, data: action.payload.content, currentPage: action.payload.number, totalPages: action.payload.totalPages, error: null, fetching: false };
    },
    UPDATE_CERTIFICATES_DATA: (state, action) => {
        return { ...state, certificatesData: action.payload };
    },
    UPDATE_ORGS_WITHOUT_CERTIFICATES_PAGE: (state, action) => {
        return { ...state, data: action.payload };
    },
}, initialState);

//- Selectors
export const getOrgsWithoutCertificates = state => state.orgsWithoutCertificates;

export const loadingOrgsWithoutCertificates = state => getOrgsWithoutCertificates(state).fetching;

export const getCurrentPageForOrgsWithoutCertificates = state => getOrgsWithoutCertificates(state).currentPage;

export const getTotalPagesForOrgsWithoutCertificates = state => getOrgsWithoutCertificates(state).totalPages;

export const getOrgsWithoutCertificatesData = state => getOrgsWithoutCertificates(state).data;

export const getOrgsWithoutCertificatesFormattedData = state => {
    let data = getOrgsWithoutCertificatesData(state);
    if (_.isNil(data)) {
        return null;
    }

    return _.map(data, org => ({
        id: org.id,
        anchorName: _.isNil(org.anchor.identityAlias) || _.isNil(org.anchor.identityAlias.firstName) || _.isNil(org.anchor.identityAlias.lastName) ?
            "" : org.anchor.identityAlias.firstName + " " + org.anchor.identityAlias.lastName,
        anchorEmail: org.anchor.email,
        orgName: org.name
    }));
};

export const getFirstCertificatesData = state => getOrgsWithoutCertificates(state).certificatesData;



// WEBPACK FOOTER //
// ./src/reducers/organization/orgsWithoutCertificates.js